import { useWindowSize } from "api/commonConstants";
import { MasterConfigContext } from "constants/MasterConfigContext";
import React, { useEffect, useState, useContext, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";


const QuickLinks = () => {

  const size = useWindowSize()

  const containerStyle = {
    border: "1px solid #eee",
    borderRadius: "12px",
    padding: "16px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
    margin: "10px 0px",
    overflow: "hidden",
  };

  const headerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "26px",
    fontWeight: "600",
    marginBottom: "12px",
    lineHeight: "43.21px",
  };

  const iconStyle = {
    // marginRight: "8px",
    fontSize: "20px",
  };

  const scrollableContainer = {
    display: "grid",
    gridTemplateRows: "repeat(1, auto)", // Always 2 rows
    gridAutoFlow: "column", // Enables horizontal scrolling
    gridAutoColumns: "max-content", // Fit content dynamically
    gap: "8px",
    overflowX: "auto", // Enables horizontal scrolling
    scrollbarWidth: "none", // Hide scrollbar (Firefox)
    msOverflowStyle: "none", // Hide scrollbar (IE/Edge)
    whiteSpace: "nowrap", // Ensures proper scrolling
  };

  // Hide scrollbar for WebKit browsers (Chrome, Safari)
  const hideScrollbar = {
    "&::-webkit-scrollbar": {
      display: "none",
    },
  };

  const linkStyle = {
    display: "block", // Ensures width matches content
    padding: "6px 16px",
    borderRadius: "10px",
    border: "1px solid #BBDFE4",
    backgroundColor: "#F9FCFD",
    cursor: "pointer",
    fontSize: size.width > 950 ? "18px" : "14px",
    fontWeight: "400",
    color: "#2D656A",
    textAlign: "center",
    fontWeight: "bold",
    whiteSpace: "nowrap", // Prevents text from wrapping
    // width:"100%"
  };

  const trendingStyle = {
    ...linkStyle,
    backgroundColor: "#F9FCFD",
    color: "#2D656A",

    border: "none",
  };





  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);




  const [list, setList] = useState(null)
  const [lang, setLang] = useState('hi')
  const masterConfig = useContext(MasterConfigContext);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          process.env.NEXT_PUBLIC_APP_API_URL + "/v1/quickLink/detail?accessType=WEB&slug=" + masterConfig?.['QuickLinks']?.['Slug'] || "champions-trophy"
        );
        // console.log(masterConfig,"master config")

        if (!response.ok) throw new Error("Network response was not ok");
        const result = await response.json();
        console.log(result);
        setList(result?.result?.links)
      } catch (error) {
        console.error("Fetch error:", error);
        console.log("Fetch error:", error?.message);
        setList(null)
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const localLanguage = JSON.parse(localStorage.getItem("i18nConfig"))
    if (localLanguage) {
      setLang(localLanguage?.selectedLang)
    }
  }, [])

  return list && masterConfig?.['QuickLinks']?.['Status'] ? (
    <div style={{}}>
      {/* <div style={headerStyle}>
      <span style={iconStyle}>🔗</span> <span className="m-0 p-0" style={{ color: "#d9368b" }}> क्विक लिंक</span>
    </div> */}

      {/* Scrollable 2-row grid */}
      <div className="position-relative" >
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          autoplay={false}
          loop={false}
          spaceBetween={5}
          slidesPerView={"auto"}
          // slidesPerView="auto"
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          className="mx-5"
        >
          {list.map((link, index) => (
            <SwiperSlide style={{ width: 'auto' }} key={index + 1} className="text-center" >
              <a href={link?.url} key={index} style={list?.isTrending ? trendingStyle : linkStyle} className="w-100">
                {lang == 'hi' ? link?.title : link?.englishTitle}
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
          <div className="mt-2 text-end position-absolute" style={{ left: "-2px", top: "-22%", zIndex: "960" }}>
            <button
              onClick={() => swiperRef.current.slidePrev()}
              className='btn  '
              disabled={activeIndex >= 1?false:true}
              style={{
                border: "none", transform: "rotate(180deg)",
                borderRadius: "10px",
                border: "1px solid #BBDFE4",
                backgroundColor: "#F9FCFD",
                minWidth: "20px"
              }}
            >

              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.19763 11.62L9.00097 7.8167C9.45013 7.36754 9.45013 6.63254 9.00097 6.18337L5.19763 2.38004" stroke="#292D32" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </button>
          </div>
          <div className="mt-2 text-end position-absolute" style={{ right: "-2px", top: "-22%", zIndex: "960" }}>
            <button
              onClick={() => swiperRef.current.slideNext()}
              className='btn  '
              disabled={activeIndex + 5 !== list?.length - 1?false:true}
              style={{
                border: "none",
                borderRadius: "10px",
                border: "1px solid #BBDFE4",
                backgroundColor: "#F9FCFD",
                minWidth: "20px"
              }}
            >

              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.19763 11.62L9.00097 7.8167C9.45013 7.36754 9.45013 6.63254 9.00097 6.18337L5.19763 2.38004" stroke="#292D32" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </button>
          </div>
      </div>
    </div>
  ) : ""
};

export default QuickLinks;